import { axiosGateway } from "@/api/axios";

const GENETIQUE_AI_PATHS = {
  ANALYZE: "/genetique-ai/genetic-risk/analyze",
};

export const generateGeneticRiskReport = async ({
  subjectUserId,
  language = "fr",
  consentAccepted = true,
  includeSpouseFamily = true,
  includeChildren = true,
} = {}) => {
  if (!subjectUserId) {
    throw new Error("Identifiant utilisateur introuvable pour lancer l'analyse IA.");
  }

  const { data } = await axiosGateway.post(GENETIQUE_AI_PATHS.ANALYZE, {
    subjectUserId,
    language,
    consentAccepted,
    includeSpouseFamily,
    includeChildren,
  });

  return data;
};
